// Module
var code = "<div class=\"rd-title-description\" data-cy=\"rd-item-{{item.title.toLowerCase()}}\"><strong>{{item.title}} <em ng-if=\"item.expired\" translate=\"course-editor_expired-license\"></em></strong><p>{{item.description}}</p></div>";
// Exports
module.exports = code;